import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    entities: {}
};

const requestConversation = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const receiveConversation = (state, action) => {
    return {
        ...state,
        isFetching: false,
        entities: { ...state.entities, [action.resourceId]: action.conversation },
        lastUpdated: action.receivedAt
    };
};

const manageLikes = (state, action) => {
    return {
        ...state,
        entities: {
            ...state.entities,
            [action.resourceId]: {
                ...state.entities[action.resourceId],
                likedByUser: action.add,
                numberOfLikes: action.add
                    ? ++state.entities[action.resourceId].numberOfLikes
                    : --state.entities[action.resourceId].numberOfLikes
            }
        }
    };
};

const manageComments = (state, action) => {
    return {
        ...state,
        entities: {
            ...state.entities,
            [action.resourceId]: {
                ...state.entities[action.resourceId],
                numberOfComments: action.add
                    ? ++state.entities[action.resourceId].numberOfComments
                    : --state.entities[action.resourceId].numberOfComments
            }
        }
    };
};

const resetToInitialState = () => INITIAL_STATE;

const handlers = {
    [types.REQUEST_CONVERSATION]: requestConversation,
    [types.RECEIVE_CONVERSATION]: receiveConversation,
    [types.MANAGE_LIKES]: manageLikes,
    [types.MANAGE_COMMENTS]: manageComments,
    [types.RESET_CONVERSATION]: resetToInitialState
};

export const getConversations = (state) => {
    return state.conversations.entities;
};

export default function conversations(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
